export default function formatToFixed8OrToInteger(value: number): string {
  const fixed8 = value.toFixed(8);
  return trimInsignificantZeros(fixed8);
}

function trimInsignificantZeros(value: string) {
  // 42.010 => 42.01
  // 42.000 => 42
  return value.replace(/\.?0+$/, "");
}
